//Código para abrir e fechar o menu com o hover do mouse

// Seleciona o contêiner que inclui todos os elementos <details>
let menuContainer = document.querySelector('.header__inline-menu');

// Adiciona um ouvinte de eventos para toda a área do menu
menuContainer.addEventListener('mouseover', (event) => {
  const target = event.target.closest('details');
  if (target) {
    target.setAttribute('open', true);
  }
});

menuContainer.addEventListener('mouseout', (event) => {
  const target = event.target.closest('details');
  if (target) {
    target.removeAttribute('open');
  }
});

// Gerencia os eventos de foco e blur usando delegação de eventos
menuContainer.addEventListener('focusin', (event) => {
  const target = event.target.closest('details');
  if (target) {
    target.setAttribute('open', true);
  }
});

menuContainer.addEventListener('focusout', (event) => {
  const target = event.target.closest('details');
  if (target) {
    target.removeAttribute('open');
  }
});

// Ouvinte de eventos para a área de submenu para fechar todos os <details> quando o mouse sai
let dropdownItems = document.querySelector('.header__submenu');
if (dropdownItems) {
  dropdownItems.addEventListener('mouseleave', () => {
    document.querySelectorAll('.header__inline-menu details[open]').forEach((item) => {
      item.removeAttribute('open');
    });
  });
}

//Fim do Código para abrir e fechar o menu com o hover do mouse

// --------- Código para clonar ícone do carrrinho no upcart

document.addEventListener('DOMContentLoaded', function () {
  var originalIcon = document.querySelector('.header__icon--cart > svg, .header__icon--cart > img');

  // Função para clonar e inserir o ícone
  function cloneAndInsertIcon(targetDiv) {
    if (originalIcon && targetDiv) {
      var clonedIcon = originalIcon.cloneNode(true);
      if (targetDiv.firstChild) {
        targetDiv.insertBefore(clonedIcon, targetDiv.firstChild);
      } else {
        targetDiv.appendChild(clonedIcon);
      }
      console.log('Ícone clonado e inserido com sucesso');
    }
  }

  // Observa mudanças no corpo do documento
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      Array.from(mutation.addedNodes).forEach(function (node) {
        // Verifica se o nó é um elemento e tem a classe 'upcart-header'
        if (node.nodeType === Node.ELEMENT_NODE && node.classList.contains('upcart-header')) {
          cloneAndInsertIcon(node);
        }

        // Verifica também dentro de qualquer nó adicionado se há 'upcart-header'
        if (node.nodeType === Node.ELEMENT_NODE && node.querySelector('.upcart-header')) {
          cloneAndInsertIcon(node.querySelector('.upcart-header'));
        }
      });
    });
  });

  // Inicia a observação
  observer.observe(document.body, { childList: true, subtree: true });

  // Verifica inicialmente se o elemento já está presente
  var targetDiv = document.querySelector('.upcart-header');
  if (targetDiv) {
    cloneAndInsertIcon(targetDiv);
  }
});

// --------------- Fim do Código para clonar ícone do carrrinho no upcart




// Função para adicionar os estilos aos formulários da Shopify
function addStylesToShadowRoot() {
  const maxAttempts = 10; // Número máximo de tentativas
  let attempts = 0; // Contador de tentativas

  const intervalId = setInterval(() => {
    const formEmbed = document.querySelector('form-embed#app-embed');

    // Verifica se o formEmbed e o shadowRoot existem
    if (formEmbed && formEmbed.shadowRoot) {
      // Acesse o Shadow DOM usando a propriedade .shadowRoot
      const shadowRoot = formEmbed.shadowRoot;

      // Crie uma nova tag <style>
      const styleTag = document.createElement('style');

      // Adicione os estilos desejados dentro da tag <style>
      styleTag.textContent = `
        @media (min-width: 768px) {
          #form-container-ref > section > section {
            border: 1px solid #222222;
            border-radius: 8px;
            padding: 0px 28px;
          }
        }
        @media (min-width: 768px) {
          #form-container-ref {
          margin: 30px;
          }
        }
      `;

      // Anexe a tag <style> ao Shadow DOM
      shadowRoot.appendChild(styleTag);

      // Limpa o intervalo após adicionar os estilos com sucesso
      clearInterval(intervalId);
    } else {
      attempts++; // Incrementa o contador de tentativas

      // Se atingir o número máximo de tentativas, para de tentar
      if (attempts >= maxAttempts) {
        clearInterval(intervalId);
        console.error('Não foi possível encontrar o elemento form-embed ou shadowRoot.');
      }
    }
  }, 100); // Intervalo de 100ms entre cada tentativa
}

// Chama a função para começar as tentativas
addStylesToShadowRoot();